/* Cats Garage — product-pairs.js
   Fetches product recommendations for [data-cg-pairs][data-url] via the
   standard section-render endpoint and swaps in the fresh grid contents
   (product cards + Cat Paradise Rewards card). On failure the server-rendered fallback
   (Cat Paradise Rewards card only) stays in place. Vanilla JS, loaded with defer. */
(function () {
  'use strict';

  document.querySelectorAll('[data-cg-pairs][data-url]').forEach(function (grid) {
    var url = grid.getAttribute('data-url');
    grid.removeAttribute('data-url');

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations failed: ' + response.status);
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-cg-pairs]');
        if (fresh && fresh.innerHTML.trim().length) {
          grid.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {
        /* keep the server-rendered fallback */
      });
  });
})();
